//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import dxTextArea, { dxTextAreaOptions } from 'devextreme/ui/text_area'
import dxTextBox, { dxTextBoxOptions } from 'devextreme/ui/text_box'
import dxTagBox, { dxTagBoxOptions } from 'devextreme/ui/tag_box'
import dxValidator, { dxValidatorResult } from 'devextreme/ui/validator'

//#endregion

import { Enums } from '../../../models/common'
import { IMRBaseControlController } from '../base'
import { ISendMail, SendMailOptions, SendMailParameters } from './send-mail.interfaces'
import { LocalizationHelper, TypeHelper } from '../../../helpers'
import { OpFile } from '../../../models/core'
import { OpEmail } from '../../../models/custom/op-email'
import { OpMessage } from '../../../models/custom/op-message'
import { UserSessionService } from '../../../services/user-session'

export class SendMailController extends IMRBaseControlController<ISendMail, SendMailOptions> implements ng.IComponentController, ISendMail {

    // Consts

    public get toText(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.To) }
    public get subjectText(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Subject) }
    public get attachmentsText(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Attachments) }

    // Consts End


    // Members

    public emailValidationRules: DevExpress.ui.dxValidatorOptions

    public sendMailEmailTagboxOptions: dxTagBoxOptions
    public sendMailSubjectTextboxOptions: dxTextBoxOptions
    public sendMailAttachmentsTagboxOptions: dxTagBoxOptions
    public sendMailTextboxOptions: dxTextAreaOptions //replace to dxHtmlEditor after DevEtreme update to higher version. it doesnt work on v.19.2.7

    private emailTagtbox: dxTagBox
    private subjectTextbox: dxTextBox
    private attachmentsTagbox: dxTagBox
    private messageTextArea: dxTextArea
    private emailValidator: dxValidator

    // Members End


    // Properties

    public submitChanges(): OpEmail {
        const validationResult: dxValidatorResult = this.emailValidator.validate()

        if (validationResult != null && validationResult.isValid) {
            const email: OpEmail = new OpEmail(null)
            const message: OpMessage = new OpMessage(null)

            message.title = this.subjectTextbox.option('value')
            message.idOperatorSender = this.userSessionService.getIdLoggedOperator()
            message.content = this.messageTextArea.option('value').replace(/\r\n/ig, "\n").replace(/\r/ig, "\n").replace(/\n/ig, "<br />")
            message.idMessageType = Enums.MessageType.EMail
            message.idMessageState = Enums.MessageState.Written

            email.message = message
            email.subject = this.subjectTextbox.option('value')
            email.emailAddresses = this.emailTagtbox.option('value')
            email.attachments = this.attachmentsTagbox.option('value')

            return email
        }

        return null
    }


    // Properties End


    // Ctor

    constructor(
        private userSessionService: UserSessionService
    ) { super() }

    // Ctor End

    protected initialize(): void {
        this.setDefaults()

        if (this.options != null) {
            this.setOptions()
        }
    }

    // Options

    private setDefaults(): void {

    }

    private setOptions(): void {
        this.initializeSendMailEmailTextboxOptions()
        this.initializeSendMailSubjectTextboxOptions()
        this.initializeSendMailAttachmentsTagboxOptions()
        this.initializeSendMailTextboxOptions()
        this.initializeEmailValidator()
    }

    private initializeSendMailEmailTextboxOptions() {
        this.sendMailEmailTagboxOptions = {
            acceptCustomValue: true,
            value: _.size(this.options.emails) > 0 ? this.options.emails : [],
            dataSource: _.size(this.options.emails) > 0 ? this.options.emails : [],
            onInitialized: (e: any) => {
                this.emailTagtbox = e.component
            }
        }
    }

    private initializeSendMailSubjectTextboxOptions() {
        this.sendMailSubjectTextboxOptions = {
            value: this.options.subject,
            onInitialized: (e: any) => {
                this.subjectTextbox = e.component
            }
        }
    }

    private initializeSendMailAttachmentsTagboxOptions() {
        this.sendMailAttachmentsTagboxOptions = {
            dataSource: this.options.attachments,
            displayExpr: (file: OpFile) => { return file != null ? file.physicalFileName : TypeHelper.emptyString },
            multiline: false,
            showSelectionControls: true,
            maxDisplayedTags: 3,
            showMultiTagOnly: false,
            // value: this.options.attachments, //Niech żadnen załącznik nie dodaje się automatycznie, ma być tylko wybór z listy i niech użytkownik podejmuje świadomą decyzję co wybrać
            onInitialized: (e: any) => {
                this.attachmentsTagbox = e.component
            }
        }
    }

    private initializeSendMailTextboxOptions() {
        this.sendMailTextboxOptions = {
            height: '100%',
            value: this.options.message,
            onInitialized: (e: any) => {
                this.messageTextArea = e.component
            }
        }
    }

    private initializeEmailValidator(): void {
        this.emailValidationRules = {
            validationRules: [{
                type: "required",
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            },],
            onInitialized: (e: any) => {
                this.emailValidator = e.component
            }
        }
    }

    // Options End
}


